import { FC } from 'react';

import { BottomSheet } from '../../../BottomSheet';
import { Modal, ModalBodyProps } from '../../../Modal';
import { useMedia } from '../../../useMedia';
import { DIALOG_DESKTOP_QUERY } from '../query';

export type ResponsiveDialogBodyProps = ModalBodyProps;

/** Modal.Body на десктопе, BottomSheet.Body на мобайле. */
const ResponsiveDialogBody: FC<ResponsiveDialogBodyProps> = (props) => {
  const isDesktop = useMedia(DIALOG_DESKTOP_QUERY);

  return isDesktop ? <Modal.Body {...props} /> : <BottomSheet.Body {...props} />;
};

export default ResponsiveDialogBody;
